import { COMPANY_API } from 'apis';

export const getCompanyServiceTypes = async (params) => {
  const result = await COMPANY_API.get(`/finance/client-contracts/service-types`, { params });
  return result.data;
};

export const getClientContracts = async (params) => {
  const result = await COMPANY_API.get(`/finance/client-contracts`, { params });
  return result.data;
};
